import { defaultIconProps, IconProps } from './IconProps';

export const IconStackCollapse: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M10 8H14M10 8L11.3333 6M10 8L11.3333 10M8 14V2" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconStackCollapse.defaultProps = defaultIconProps;
